export const getPreferredSetupGuideTab = () => {
  if (typeof navigator === 'undefined') {
    return 'bark';
  }

  const userAgent = navigator.userAgent || '';
  const platform = navigator.platform || '';
  const isAndroid = /Android/i.test(userAgent);
  const isIOS = /iPhone|iPad|iPod/i.test(userAgent);
  const isIPadOS = platform === 'MacIntel' && navigator.maxTouchPoints > 1;

  if (isAndroid) {
    return 'wxPlugin';
  }

  if (isIOS || isIPadOS) {
    return 'bark';
  }

  return 'bark';
};
